<template>
  <div class="page-container overflow-hidden w-[full] h-full mx-auto bg-white-400">
    <!-- Tabs & Search -->
    <div class="custom-tabs bg-gray-400 flex flex-col lg:flex-row items-center justify-between" >
      <div class="w-full flex flex-col lg:flex-row items-center justify-between ">
        <el-tabs class="w-full ml-0 lg:ml-24 uppercase text-center">
          <el-tab-pane label="Inbox Placement" name="first"></el-tab-pane>
          <el-tab-pane label="Sending Volume" name="second"></el-tab-pane>
          <el-tab-pane label="Overlap" name="third"></el-tab-pane>
        </el-tabs>
        <!-- Search Input Field -->
        <div class="searchButton w-[80px] sm:w-full lg:w-[30rem] lg:mt-0 ml-2 lg:mr-2 mb-3">
          <search-auto-fill @update-domain="updateDomain" />
        </div>
      </div>
    </div>
    <!-- Chart Section -->
    <div class="chart-container">
      <mixed-chart
        :domainName="selectedDomain"
        :daysType="daysType"
        :fromDate="fromDate"
        :toDate="toDate"
      />
    </div>
    <!-- Date Filters & Dropdown -->
    <div class="flex flex-wrap lg:flex-nowrap items-center lg:w-auto ml-6 lg:ml-32 gap-2 lg:gap-2 mt-2 ">
      <!-- Date Pickers: To & From -->
      <div class="flex items-center gap-4 sm:gap-6 flex-nowrap w-[98%] sm:w-auto">
        <span class="text-gray-600 text-xs sm:text-sm font-bold uppercase">To</span>
        <el-date-picker v-model="toDate" type="date"  @change="emitDateUpdate" placeholder="Pick day" size="small" class="w-24 sm:w-auto" />
        <span class="text-gray-600 text-xs sm:text-sm font-bold uppercase">From</span>
        <el-date-picker v-model="fromDate" type="date"  @change="emitDateUpdate" placeholder="Pick day" size="small" class="w-24 sm:w-auto" />
      </div>
      <!-- Dropdown: 20% Width on Desktop, Full Width on Small Screens -->
      <div class="dropdown-section w-[97%] lg:w-1/5">
        <el-select v-model="daysType"  @change="emitDateUpdate" size="small" class="w-full">
          <el-option value="7_days" label="Last 7 Days"></el-option>
          <el-option value="15_days" label="Last 15 Days"></el-option>
          <el-option value="30_days" label="Last 30 Days"></el-option>
          <el-option value="60_days" label="Last 60 Days (2 Months)"></el-option>
          <el-option value="90_days" label="Last 90 Days (3 Months)"></el-option>
        </el-select>
      </div>
    </div>
    <!-- Table -->
      <inbox-table :domainName="selectedDomain" />
    </div>
</template>
<script>
import emailDashboard from "./emailDashboard";
export default emailDashboard;
</script>

<style lang="scss" src="./emailDashboard.scss"></style>